import React from "react";

function Navigation_post(){
    return(
        <div className="navigation-post">
            <a href="#!" className="next-post">
                <i className="fas fa-angle-double-right"></i>
                پست بعدی
            </a>
            <a href="#!" className="prev-post">
                پست قبلی
                <i className="fas fa-angle-double-left"></i>
            </a>
        </div>
    );
}

export default Navigation_post;